
import { reactive, toRefs, defineComponent, ref, nextTick } from 'vue'
import { useRouter } from 'vue-router'
// import { useI18n } from 'vue-i18n'
import { useStore } from '@/store/index.ts'
export default defineComponent({
  name: 'layoutBreadcrumbSearch',
  setup () {
    const layoutMenuAutocompleteRef = ref()
    // const { t } = useI18n()
    const store = useStore()
    const router = useRouter()
    const state: any = reactive({
      isShowSearch: false,
      menuQuery: '',
      tagsViewList: []
    })
    // 搜索弹窗打开
    const openSearch = () => {
      state.menuQuery = ''
      state.isShowSearch = true
      initTageView()
      nextTick(() => {
        layoutMenuAutocompleteRef.value.focus()
      })
    }
    // 搜索弹窗关闭
    const closeSearch = () => {
      state.isShowSearch = false
    }
    // 菜单搜索数据过滤
    const menuSearch = (queryString: any, cb: any) => {
      const results = queryString ? state.tagsViewList.filter(createFilter(queryString)) : state.tagsViewList
      cb(results)
    }
    // 菜单搜索过滤
    const createFilter = (queryString: any) => {
      return (restaurant: any) => {
        return (
          restaurant.path.toLowerCase().indexOf(queryString.toLowerCase()) > -1 ||
					restaurant.meta.title.toLowerCase().indexOf(queryString.toLowerCase()) > -1 // ||
					// t(restaurant.meta.title).indexOf(queryString.toLowerCase()) > -1
        )
      }
    }
    // 初始化菜单数据
    const initTageView = () => {
      if (state.tagsViewList.length > 0) return false
      store.state.tagsViewRoutes.tagsViewRoutes.map((v: any) => {
        if (!v.meta.isHide) state.tagsViewList.push({ ...v })
      })
    }
    // 当前菜单选中时
    const onHandleSelect = (item: any) => {
      const { path, redirect } = item
      if (item.meta.isLink && !item.meta.isIframe) window.open(item.meta.isLink)
      else if (redirect) router.push(redirect)
      else router.push(path)
      closeSearch()
    }
    // input 失去焦点时
    const onSearchBlur = () => {
      closeSearch()
    }
    return {
      layoutMenuAutocompleteRef,
      openSearch,
      closeSearch,
      menuSearch,
      onHandleSelect,
      onSearchBlur,
      ...toRefs(state)
    }
  }
})
